// extracted by mini-css-extract-plugin
export default {"field-error-text":"field-error-text","fieldErrorText":"field-error-text"};